// backwards compatibility requires that we keep the previous spacing scale
// the increments of 5 values will be removed eventually
var space = [
    '0px',
    '5px',
    '10px',
    '15px',
    '20px',
    '25px',
    '30px',
    '40px',
    '50px',
    // -- new values below -- //
    '4px',
    '8px',
    '16px',
    '24px',
    '32px',
    // xl is at position 7 already
    '48px',
    '64px',
];
space.none = space[0];
space.xxs = space[9];
space.xs = space[10];
space.sm = space[11];
space.md = space[12];
space.lg = space[13];
space.xl = space[7];
space.xxl = space[14];
space.xxxl = space[15];
export { space };
//# sourceMappingURL=space.js.map